import { getRailsClient } from "../client";
import { Experiment, Variant } from "./types/experimentTypes";

// The hint text rendered directly in a <pre> tag — response is a plain string.
// TODO: confirm against Rails ExperimentStepPresenters if shape ever changes
type ExerciseStepResponse = string;

// TODO: convert to using new catalog endpoint
export const fetchExerciseDetails = async (lessonId: string) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/levels/undefined/lessons/${lessonId}/experiments`;
    const { data } = await client.get<Experiment>(API);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchExerciseDetailsByKey = async (contentKey: string) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/atlas/v1/exercises/${contentKey}`;
    const { data } = await client.get<Experiment>(API);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchExerciseStep = async (step: string) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/experiment_steps/${step}`;
    const { data } = await client.get<ExerciseStepResponse>(API);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchExerciseVariant = async (exerciseId: number) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/experiments/${exerciseId}/variants`;
    const { data } = await client.get<Variant>(API);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
